/**
 * Fiskal Cloud Management Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.1.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Virtual TSS Metadata
 */
export interface VirtualTssMetadataDTO { 
    /**
     * Port of FCC
     */
    port?: number;
    /**
     * Installation UUID (only installer)
     */
    installationId?: string;
    /**
     * Defined connection protocol (http or https)
     */
    protocol?: string;
}

export class ClsVirtualTssMetadataDTO { 
    /**
     * Port of FCC
     */
    port?: number = undefined;
    /**
     * Installation UUID (only installer)
     */
    installationId?: string = undefined;
    /**
     * Defined connection protocol (http or https)
     */
    protocol?: string = undefined;
}

